import { render, staticRenderFns } from "./PersonalInfoForm.vue?vue&type=template&id=c2fc455e&scoped=true&"
import script from "./PersonalInfoForm.vue?vue&type=script&lang=js&"
export * from "./PersonalInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2fc455e",
  null
  
)

export default component.exports